import classNames from "classnames";

import InlineCommentFormInput from "./InlineCommentFormInput";
import InlineCommentPublishedCard from "./InlineCommentPublishedCard";

// Renders the inline comment body: the create form (always mounted to preserve
// drafts), the edit form, and the published comment card. The trigger button
// and all state live in the parent (SuggestionCardContent via useInlineComment).
//
const InlineCommentForm = ({
  isFormOpen,
  isEditing,
  isSubmitting,
  publishedComment,
  submitLabel,
  commentFormRef,
  className,
  onSubmit,
  onCancel,
  onEdit,
  onDelete
}) => {
  const containerClassName = classNames("inline-comment-input", className);

  // The create form is always mounted so the user's draft is preserved when
  // they toggle the form closed and reopen it. It is hidden via CSS when not
  // in use (i.e. when the form is closed or when the edit form is active).
  const createFormClassName = classNames({ "d-none": !isFormOpen || isEditing });

  return (
    <div className={containerClassName}>
      <div className={createFormClassName}>
        <InlineCommentFormInput
          comment={{}}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          submitLabel={submitLabel}
          ref={!isEditing ? commentFormRef : null}
        />
      </div>

      {isEditing && isFormOpen && (
        <InlineCommentFormInput
          comment={publishedComment || {}}
          onSubmit={onSubmit}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
          submitLabel={submitLabel}
          ref={commentFormRef}
          showCancel
          isEditing
        />
      )}

      {publishedComment && !isEditing && !isFormOpen && (
        <InlineCommentPublishedCard
          comment={publishedComment}
          onEdit={onEdit}
          onDelete={onDelete}
          isDeleting={isSubmitting}
        />
      )}
    </div>
  );
};

export default InlineCommentForm;
